<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-pay-doctor`"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorPrice()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t("surgery.Are you sure do you want to pay doctor for this surgery")
        }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-pay-all-doctor-prices`"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payAllDoctorSurgerys()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor-all") }}</h5>
        {{ $t("surgery.pay-all-doctor-surgery-disc") }}
        <div>
          <div>
            {{ $t("hospital.doctorTotalDiscount") }} :
            {{ doctorTotals.total_discount_for_unpaid_surgeries }}
          </div>
          <div>
            {{ $t("hospital.doctorTotalPrices") }} :
            {{ doctorTotals.total_price_for_unpaid_surgeries }}
          </div>
          <h4>
            {{ $t("hospital.doctorTotalAfterDiscount") }} :
            {{
              doctorTotals.total_price_for_unpaid_surgeries -
              doctorTotals.total_discount_for_unpaid_surgeries
            }}
          </h4>
        </div>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-pay-doctor-stay`"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorForStay()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t(
            "surgery.Are you sure do you want to pay doctor for this patient stay"
          )
        }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-pay-doctor-consultancies`"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payConsultancies()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t(
            "surgery.Are you sure do you want to pay doctor for this consultancy"
          )
        }}
      </b-card-text>
    </b-modal>
    <b-card>
      <b-tabs v-model="activeTab">
        <b-tab
          :title="$t('accounting.dosnt-recive-money')"
          :active="activeTab === 0"
        >
          <h1 class="text-center my-2 mt-4">
            {{ $t("hospital.doctor-surgeries") }}
          </h1>
          <div>
            <b-row class="mt-5 mb-2">
              <b-col>
                <h4>
                  {{ $t("hospital.doctorTotalAfterDiscount") }} <br />
                  <b-badge class="mt-1" variant="primary">{{
                    formatIQDCurrency(
                      doctorTotals.total_price_for_unpaid_assistant_surgeries
                    )
                  }}</b-badge>
                </h4>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mt-4">
              <b-col lg="2">
                <b-form-group
                  :label="$t('hospital.patient-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="name"
                    :placeholder="$t('hospital.patient-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <AutoComplete
                  v-model="surgery_id"
                  :label="$t('surgery.surgery')"
                  :placeholder="$t('surgery.surgery')"
                  :serializer="(val) => val.id"
                  param-query="search"
                  :endpoint="`surgery`"
                  text-title="title"
                />
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  @click="getDoctorsSurgeries()"
                  class="mx-2"
                >
                  {{ $t("common.search") }}
                  <!-- <b-icon-search class="ml-1"></b-icon-search> -->
                </b-button>
                <b-button variant="primary" @click="showModalPayAll()">
                  {{ $t("surgery.payAllSurgerys") }}
                </b-button>
              </b-col>
            </b-row>

            <b-table
              :items="data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(doctors_financial)="data">
                <b-button variant="primary" @click="showModal(data.item)">
                  {{ $t("surgery.pay-doctor") }}
                </b-button>
              </template>
              <template #cell(amount)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_surgery.price) }}
                </span>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getDoctorsSurgeries()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>

          <!--------------------------------- surgery consultancies---------------------------------- -->
          <div
            class="d-flex align-items-center my-4"
            style="margin-top: 200px !important"
          >
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
            <div class="mx-3" style="color: rgba(0, 0, 0, 0.3)">
              <feather-icon icon="ScissorsIcon" size="25" />
            </div>
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
          </div>
          <h1 class="text-center">
            {{ $t("surgery.doctor-consultancies") }}
          </h1>
          <div>
            <b-row class="mt-5 mb-2">
              <!-- <b-col cols="12" lg="4">
                <h5>
                  {{ $t("hospital.doctorTotalPrices") }} <br />
                  <b-badge class="mt-1" variant="secondary">{{
                    formatIQDCurrency(
                      doctorPatientStayTotals.total_price_for_unpaid_stays
                    )
                  }}</b-badge>
                </h5>
              </b-col> -->
              <b-col>
                <h4>
                  {{ $t("hospital.total_price_for_unpaid_stays") }}:
                  <b-badge class="mt-1" variant="primary">{{
                    formatIQDCurrency(consultanciesTotals)
                  }}</b-badge>
                </h4>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mt-4">
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  @click="getSurgeryConsultancies()"
                  class="mx-2"
                >
                  {{ $t("common.search") }}
                  <!-- <b-icon-search class="ml-1"></b-icon-search> -->
                </b-button>
              </b-col>
            </b-row>

            <b-table
              :items="consultanciesData"
              responsive
              :fields="consultanciesTableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(patient_card_surgery.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_surgery.price) }}
                </span>
              </template>
              <template #cell(actions)="data">
                <b-button
                  variant="primary"
                  @click="showModalConsultancies(data.item)"
                >
                  {{ $t("surgery.pay-doctor") }}
                </b-button>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price) }}
                </span>
              </template>
              <template #cell(patient_card_stay.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_stay.price) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getSurgeryConsultancies()"
                >
                  <b-pagination
                    v-model="consultanciesPage"
                    :total-rows="consultanciesDataCount"
                    :per-page="consultanciesTake"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>

          <!--------------------------------- patient stay---------------------------------- -->
          <div
            class="d-flex align-items-center my-4"
            style="margin-top: 200px !important"
          >
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
            <div class="mx-3" style="color: rgba(0, 0, 0, 0.3)">
              <feather-icon icon="ScissorsIcon" size="25" />
            </div>
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
          </div>
          <h1 class="text-center">
            {{ $t("hospital.doctor-patient-stay") }}
          </h1>
          <div>
            <b-row class="mt-5 mb-2">
              <!-- <b-col cols="12" lg="4">
                <h5>
                  {{ $t("hospital.doctorTotalPrices") }} <br />
                  <b-badge class="mt-1" variant="secondary">{{
                    formatIQDCurrency(
                      doctorPatientStayTotals.total_price_for_unpaid_stays
                    )
                  }}</b-badge>
                </h5>
              </b-col> -->
              <b-col>
                <h4>
                  {{ $t("hospital.total_price_for_unpaid_stays") }}:
                  <b-badge class="mt-1" variant="primary">{{
                    formatIQDCurrency(doctorPatientStayTotals)
                  }}</b-badge>
                </h4>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mt-4">
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  @click="getDoctorPatientStay()"
                  class="mx-2"
                >
                  {{ $t("common.search") }}
                  <!-- <b-icon-search class="ml-1"></b-icon-search> -->
                </b-button>
              </b-col>
            </b-row>

            <b-table
              :items="doctorPatientStayData"
              responsive
              :fields="doctorPatientStayTableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(actions)="data">
                <b-button variant="primary" @click="showModalStay(data.item)">
                  {{ $t("surgery.pay-doctor") }}
                </b-button>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price) }}
                </span>
              </template>
              <template #cell(patient_card_stay.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_stay.price) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getDoctorPatientStay()"
                >
                  <b-pagination
                    v-model="doctorPatientStayPage"
                    :total-rows="doctorPatientStayDataCount"
                    :per-page="doctorPatientStayTake"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
        <b-tab :title="$t('accounting.recive-money')" :active="activeTab === 1">
          <div>
            <!-- Data Table  -->
            <div class="d-flex justify-content-between mb-2">
              <h2>{{ $t("hospital.doctor-surgeries") }}</h2>
            </div>

            <b-row class="d-flex justify-content-end">
              <b-col lg="3">
                <b-form-group
                  :label="$t('hospital.patient-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="name"
                    :placeholder="$t('hospital.patient-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <AutoComplete
                  v-model="surgery_id"
                  :label="$t('surgery.surgery')"
                  :placeholder="$t('surgery.surgery')"
                  :serializer="(val) => val.id"
                  param-query="search"
                  :endpoint="`surgery`"
                  text-title="title"
                />
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0" lg="2">
                <b-button variant="primary" @click="getDoctorsSurgeries()">
                  {{ $t("common.search") }}
                  <b-icon-search class="ml-1"></b-icon-search>
                </b-button>
              </b-col>
            </b-row>

            <b-table
              :items="data"
              responsive
              :fields="tableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(doctors_financial)="data">
                <span style="color: green; font-size: large; font-weight: bold">
                  {{ $t("surgery.doctor has received pay") }}
                </span>
              </template>
              <template #cell(amount)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.amount) }}
                </span>
              </template>
              <template #cell(patient_card_surgery.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_surgery.price) }}
                </span>
              </template>
              <template #cell(doctor_discount)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_discount) }}
                </span>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price) }}
                </span>
              </template>
              <template #cell(patient_card_surgery.surgery_date_time)="data">
                <span class="text-nowrap">
                  {{ data.item.patient_card_surgery.surgery_date_time }}
                </span>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <div class="text-nowrap d-flex"></div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getDoctorsSurgeries()"
                >
                  <b-pagination
                    v-model="page"
                    :total-rows="dataCount"
                    :per-page="take"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>

          <!--------------------------------- surgery consultancies---------------------------------- -->
          <div
            class="d-flex align-items-center my-4"
            style="margin-top: 200px !important"
          >
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
            <div class="mx-3" style="color: rgba(0, 0, 0, 0.3)">
              <feather-icon icon="ScissorsIcon" size="25" />
            </div>
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
          </div>
          <h1 class="text-center">
            {{ $t("surgery.doctor-consultancies") }}
          </h1>
          <div>
            <b-row class="d-flex justify-content-end mt-4">
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  @click="getSurgeryConsultancies()"
                  class="mx-2"
                >
                  {{ $t("common.search") }}
                  <!-- <b-icon-search class="ml-1"></b-icon-search> -->
                </b-button>
              </b-col>
            </b-row>

            <b-table
              :items="consultanciesData"
              responsive
              :fields="consultanciesTableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(patient_card_surgery.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_surgery.price) }}
                </span>
              </template>
              <template #cell(actions)="data">
                <span style="color: green; font-size: large; font-weight: bold">
                  {{ $t("surgery.doctor has received pay") }}
                </span>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.dodoctor_assistant_pricector_price) }}
                </span>
              </template>
              <template #cell(patient_card_stay.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_stay.price) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getSurgeryConsultancies()"
                >
                  <b-pagination
                    v-model="consultanciesPage"
                    :total-rows="consultanciesDataCount"
                    :per-page="consultanciesTake"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>

          <!------------------- pay doctor patient stay ------------------->
          <div
            class="d-flex align-items-center my-4"
            style="margin-top: 200px !important"
          >
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
            <div class="mx-3" style="color: rgba(0, 0, 0, 0.3)">
              <feather-icon icon="ScissorsIcon" size="25" />
            </div>
            <div
              class="flex-grow-1"
              style="border-top: 5px solid rgba(0, 0, 0, 0.2)"
            ></div>
          </div>
          <h1 class="text-center">
            {{ $t("hospital.doctor-patient-stay") }}
          </h1>
          <div>
            <b-row class="d-flex justify-content-end mt-4">
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  ></datepicker>
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  @click="getDoctorPatientStay()"
                  class="mx-2"
                >
                  {{ $t("common.search") }}
                  <!-- <b-icon-search class="ml-1"></b-icon-search> -->
                </b-button>
              </b-col>
            </b-row>

            <b-table
              :items="doctorPatientStayData"
              responsive
              :fields="doctorPatientStayTableColumns"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
              v-if="!loading"
            >
              <template #cell(actions)="data">
                <span style="color: green; font-size: large; font-weight: bold">
                  {{ $t("surgery.doctor has received pay") }}
                </span>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price) }}
                </span>
              </template>
              <template #cell(patient_card_stay.price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.patient_card_stay.price) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  @click="getDoctorPatientStay()"
                >
                  <b-pagination
                    v-model="doctorPatientStayPage"
                    :total-rows="doctorPatientStayDataCount"
                    :per-page="doctorPatientStayTake"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BIconSearch,
  BTab,
  BTabs,
  BBadge,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BIconSearch,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    Datepicker,
    AutoComplete,
    BTab,
    BTabs,
    ToastificationContent,
    BBadge,
  },

  props: ["patientCardId", "isHistory"],
  data() {
    return {
      params: {
        form: {},
        path: "",
      },
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      activeTab: 0,
      tableColumns: [
        {
          key: "patient_card_surgery.patient_card.patient.name",
          label: this.$t("hospital.patient-name"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "patient_card_surgery.patient_card.patient.phone",
          label: this.$t("hospital.patient-phone"),
          sortable: true,
          class: "text-nowrap",
        },

        {
          key: "patient_card_surgery.surgery.title",
          label: this.$t("surgery.surgery"),
          sortable: true,
        },
        {
          key: "amount",
          label: this.$t("reception.Surgery Price"),
          sortable: true,
        },
      
        {
          key: "doctor_assistant_price",
          label: this.$t("accounting.doctor_assistant_price"),
          sortable: true,
        },
        {
          key: "doctors_financial",
          label: this.$t("surgery.pay-doctor"),
        },
        {
          key: "patient_card_surgery.surgery_date_time",
          sortable: true,
          label: this.$t("hospital.surgery-date"),
        },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      surgery_id: "",
      payDoctorData: {},
      doctorTotals: {},
      // for doctor patient stay
      doctorPatientStayTotals: 0,
      doctorPatientStayData: [],
      doctorPatientStayDataCount: 0,
      doctorPatientStayPage: 1,
      doctorPatientStayTake: 10,
      from: "",
      to: "",
      doctorPatientStayTableColumns: [
        {
          key: "patient_card_stay.patient_card.patient.name",
          label: this.$t("hospital.patient-name"),
          sortable: true,
        },
        {
          key: "doctor_price",
          label: this.$t("surgery.doctor_price"),
          sortable: true,
        },
        {
          key: "patient_card_stay.price",
          label: this.$t("hospital.total-price-patient-stay"),
          sortable: true,
        },
        {
          key: "patient_card_stay.stay_date_time",
          label: this.$t("hospital.stay_date_time"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
        {
          key: "created_at",
          label: this.$t("common.created_at"),
          sortable: true,
        },
      ],
      payDoctorStayData: {},

      // ---- New properties for consultancies table ----
      consultanciesData: [],
      consultanciesDataCount: 0,
      consultanciesPage: 1,
      consultanciesTake: 20,
      consultanciesTotals: 0,
      consultanciesTableColumns: [
        {
          key: "patient_card_surgery.patient_card.patient.name",
          label: this.$t("hospital.patient-name"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "doctor_price",
          label: this.$t("surgery.Doctor-consultancy-price"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "patient_card_surgery.price",
          label: this.$t("reception.Surgery Price"),
          sortable: true,
        },
        {
          key: "patient_card_surgery.patient_card.patient.phone",
          label: this.$t("hospital.patient-phone"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "patient_card_surgery.surgery.title",
          label: this.$t("surgery.surgery"),
          sortable: true,
          class: "text-nowrap",
        },
        {
          key: "patient_card_surgery.surgery_date_time",
          label: this.$t("hospital.surgery-date"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
        {
          key: "created_at",
          label: this.$t("common.created_at"),
          sortable: true,
        },
      ],
      payConsultanciesData: {},
    };
  },
  mounted() {
    this.getDoctorsSurgeries();
    // this.getDoctorPatientStay();
    // this.getSurgeryConsultancies(); // call the new function on mount
  },
  watch: {
    activeTab() {
      this.getDoctorsSurgeries();
      this.getDoctorPatientStay();
      this.getSurgeryConsultancies(); // update consultancies when tab changes
    },
  },
  methods: {
    // for doctor patient stay
    async getDoctorPatientStay() {
      this.loading = true;
      let url = `/patient-stay/doctor/${this.$route.params.id}?page=${this.doctorPatientStayPage}&take=${this.doctorPatientStayTake}&include=patientCardStay&sort=-id&filter[payment_status]=${this.activeTab}`;
      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }

      await this.getList(url);

      this.doctorPatientStayTotals = this.all_data.total_price_for_unpaid_stays;
      this.doctorPatientStayDataCount = this.all_data.data.total;
      this.doctorPatientStayData = this.all_data.data.data;

      this.loading = false;
    },

    // for doctor surgeries
    formatIQDCurrency(value) {
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      // Format the value and return it
      return formatter.format(value);
    },
    showModal(status) {
      this.$bvModal.show("modal-pay-doctor");
      this.payDoctorData = status;
    },
    showModalPayAll() {
      this.$bvModal.show("modal-pay-all-doctor-prices");
    },
    getDoctorPrice(doctorsPrices) {
      if (!doctorsPrices || !doctorsPrices.items) {
        return "Price not available";
      }

      const doctorItem = doctorsPrices.items.find(
        (item) => item && item.doctor_id == this.$route.params.id
      );

      return doctorItem?.price || "Price not available";
    },
    getDoctorDiscount(doctorsDiscounts) {
      if (!doctorsDiscounts || !doctorsDiscounts.items) {
        return "Price not available";
      }

      const doctorItem = doctorsDiscounts.items.find(
        (item) => item && item.doctor_id == this.$route.params.id
      );

      return doctorItem?.doctor_discount || "0";
    },
    async getDoctorsSurgeries() {
      this.loading = true;
      // &include=surgery
      // check if there are any null value in the obj we sending
      let url = `/patient-surgery/doctor-assistant/${this.$route.params.id}?page=${this.page}&take=${this.take}&include=doctorAssistant,patientCardSurgery&payment_status=${this.activeTab}&sort=-created_at`;
      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }
      if (this.name) {
        url += `&filter[patientCard.patient.name]=${this.name}`;
      }
      if (this.surgery_id) {
        url += `&filter[surgery_id]=${this.surgery_id}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.data.total;
      this.data = this.all_data.data.data;
      this.loading = false;
      this.doctorTotals = {
        total_price_for_unpaid_assistant_surgeries:
          this.all_data.total_price_for_unpaid_assistant_surgeries,
      };
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    payAllDoctorSurgerys() {
      const data = {
        doctor_id: this.$route.params.id,
      };
      (this.params.form = data),
        (this.params.path = `/payDoctorAssistant`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getDoctorsSurgeries();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "pay doctor",
                variant: "success",
                text: "Doctor has been paid successfully",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    payDoctorPrice() {
      const data = {
        doctor_id: this.$route.params.id,
        patient_card_surgery_id: this.payDoctorData.patient_card_surgery_id,
      };
      (this.params.form = data),
        (this.params.path = `/payDoctorAssistant`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.getDoctorsSurgeries();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "pay doctor",
                variant: "success",
                text: "Doctor has been paid successfully",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    showModalStay(item) {
      this.$bvModal.show("modal-pay-doctor-stay");
      this.payDoctorStayData = item;
    },
    async payDoctorForStay() {
      const data = {
        doctor_id: this.$route.params.id,
        patient_card_stay_id: this.payDoctorStayData.patient_card_stay_id,
      };

      try {
        this.params.form = data;
        this.params.path = `/payDoctorForPatientStays`;
        await this.$store.dispatch("put", this.params);

        this.getDoctorPatientStay();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Pay Doctor",
            variant: "success",
            text: "Doctor has been paid successfully for the patient stay",
          },
        });
      } catch (error) {
        if (error.response?.status === 400) {
          for (let item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          }
        }
      }
    },

    // ---- New method for getting surgery consultancies ----
    async getSurgeryConsultancies() {
      this.loading = true;
      let url = `/patient-surgery-consultancies/doctor/${this.$route.params.id}?page=${this.consultanciesPage}&take=${this.consultanciesTake}&include=patientCardSurgery&filter[payment_status]=${this.activeTab}&sort=-created_at`;
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }
      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      await this.getList(url);
      this.consultanciesDataCount = this.all_data.data.total;
      this.consultanciesData = this.all_data.data.data;
      this.consultanciesTotals =
        this.all_data.total_price_for_unpaid_consultancies || 0;
      this.loading = false;
    },
    // ---- End new method ----

    // Call this from the consultancies table action button to show the modal
    showModalConsultancies(item) {
      this.$bvModal.show("modal-pay-doctor-consultancies");
      this.payConsultanciesData = item;
    },

    // New method using API payDoctorForPatientConsultancies
    payConsultancies() {
      const data = {
        doctor_id: this.$route.params.id,
        patient_card_surgery_id:
          this.payConsultanciesData.patient_card_surgery_id,
      };

      this.params.form = data;
      this.params.path = `/payDoctorForPatientConsultancies`;

      this.$store
        .dispatch("put", this.params)
        .then((response) => {
          // Refresh the consultancies list after a successful payment
          this.getSurgeryConsultancies();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "pay doctor",
              variant: "success",
              text: "Doctor has been paid successfully for this consultancy",
            },
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            for (let key in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "validation error",
                  variant: "danger",
                  text: error.response.data[key][0],
                },
              });
            }
          }
        });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
